export function isNeedToShowUserMenuThemeModeIcons() {
  return true
}
